export default class ContestIdsSnippetNotFoundError extends Error {}
